import React from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import Register from './Register'; 

const RegisterWithCaptcha = (props) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  return <Register {...props} executeRecaptcha={executeRecaptcha} />;
};

export default RegisterWithCaptcha;
